module.exports = __webpack_public_path__ + "static/img/book3.960cc42.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/book3.png
// module id = hmFQ
// module chunks = 0